import messageResource from '../messageResource'
import {getFeaturesChangesMessage} from '../features/utils'
import {loadEditTaskPanelDataAction} from '../panels/task/editPanel/actions'

export const handleFeatureChange = (changedFeatures) => () => {
    const message = getFeaturesChangesMessage(changedFeatures).concat(messageResource.getMessage('common.interface_will_reloaded'))
    alert(message)
    window.location.reload()
}

const taskPanelErrorHandler = (taskId, error) => {
    if (error.errorThrown.exception === "com.actimind.actitime.task.NoSuchTaskException") {
        alert(messageResource.getMessage("task.error.concurrently_deleted.cannot_edit"))
        error.handle()
        window.location.reload()
    }

    if (error.errorThrown.exception === "com.actimind.actitime.services.EditTaskService$NoRightsToManageTaskException") {
        alert(messageResource.getMessage("task.edit_popup.no_rights_to_manage_tasks"))
        error.handle()
        window.location.reload()
    }

    if (error.errorThrown.exception === "com.actimind.actitime.task.TaskIsNotAssignedToUserException") {
        alert(messageResource.getMessage("task.error.task_not_assigned"));
        error.handle()
        window.location.reload()
    }

    if (error.errorThrown.exception === 'com.actimind.actitime.services.NoRightToEditHierarchyException') {
        alert(messageResource.getMessage('common.no_rights_for_operation_anymore'))
        error.handle()
        window.location.reload()
    }

    return error.isHandled()
}

export const loadEditTaskPanelData = loadEditTaskPanelDataAction(taskPanelErrorHandler)



// WEBPACK FOOTER //
// ./web/js/user/actions.js